import { render, staticRenderFns } from "./master-business-payment.vue?vue&type=template&id=83e24956"
import script from "./master-business-payment.vue?vue&type=script&lang=js"
export * from "./master-business-payment.vue?vue&type=script&lang=js"
import style0 from "./master-business-payment.vue?vue&type=style&index=0&id=83e24956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports